import React from "react";
import Avatar from "@mui/material/Avatar";
import {makeStyles} from "@mui/styles";
import {Colors} from "../assets/colors/Colors";
import {getAcronymName, getRandomColor} from "../util/functions";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: "0px 8px 0px 8px",
        },
    },
    color: {
        color: Colors.WHITE,
    }
}));


const AvatarLetters = ({text, color}) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
        <Avatar className={classes.color} style={{backgroundColor: color ? color : getRandomColor()}}>{getAcronymName(text)}</Avatar>
        </div>
    );


}

export default React.memo(AvatarLetters);
